import React from 'react';
import PropTypes from 'prop-types';
import videojs from 'video.js';

import './VideoWrapper.css';

class Video extends React.Component {
  componentDidMount() {
    const options = {
      autoplay: this.props.autoPlay || false,
      loop: this.props.loop || false,
      muted: this.props.muted || false,
      controls: this.props.controls || false,
      aspectRatio: '16:9',
      poster: this.props.poster,
      playsinline: true,
      sources: [{
        src: this.props.videoUrl,
        type: 'video/mp4'
      }],
    };

    if (this.videoNode !== undefined) {
      this.player = videojs(this.videoNode, options);
    }
  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose()
    }
  }

  render() {
    return (
      <div data-vjs-player className={ `video-component-wrapper ${ this.props.extraClass }` }>
        <div className="video-border">
          <video
            ref={ node => this.videoNode = node }
            className="video-js"
            data-title={ this.props.title }
          ></video>
        </div>
      </div>
    );
  }
}

Video.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  poster: PropTypes.string,
  extraClass: PropTypes.string,
};

export default Video;



// WEBPACK FOOTER //
// ./src/components/global/Video/index.js